import { useApolloClient, useReactiveVar } from '@apollo/client'
import { Stack, Typography } from '@mui/material'
import FormikForm, { FormikField } from '../../../../component/formikForm'
import onDeleteShipping from '../../shippings/onDelete'
import onUpdateShipping from '../../shippings/onUpdate'
import { userEntityRelationVar } from '../../../../client/cache'

export default function Item({ data, onClose }) {
  const client = useApolloClient()
  const { isUserEntityAdmin, userRole } = useReactiveVar(userEntityRelationVar)
  const isAdmin = userRole === 'systemAdmin' || isUserEntityAdmin

  const onDeleteBtnClick = async () => {
    if (window.confirm('Are you sure you wish to delete this item?')) {
      await onDeleteShipping({ values: data, client, type: 'RECEIVING' })
      onClose()
    }
  }

  return (
    <FormikForm
      initialValues={{ ...data, isEditing: false }}
      validationSchema={null}
      FormMainFields={(props) => <EditFields {...props} isAdmin={isAdmin} />}
      FormArray={null}
      handleCancel={({ setFieldValue, setValues }) => {
        setValues(data)
        setFieldValue('isEditing', false)
      }}
      saveButtonLabel='update'
      onDelete={onDeleteBtnClick}
      onSubmit={isAdmin ? ({ values, client }) => onUpdateShipping({ values, client }) : null}
      disableEdit={!isAdmin}
    />
  )
}

const EditFields = ({ values, isAdmin }) => {
  const { date, number, itemNumber, material, materialEntityRelation, qty, isEditing } =
    values
  return (
    <Stack spacing={3}>
      <Stack direction='row' spacing={5}>
        <Typography> DATE: {date}</Typography>
        <Typography> NUMBER: {number}</Typography>
        <Typography> ITEM NUMBER: {itemNumber}</Typography>
      </Stack>

      <Stack direction='row' spacing={5}>
        {materialEntityRelation && (
          <Typography> CODE: {materialEntityRelation?.code}</Typography>
        )}

        <Typography> MFR: {material?.mfr}</Typography>
        <Typography> MPN: {material?.mpn}</Typography>
      </Stack>
      <Stack direction='row' spacing={5}>
        {isAdmin && isEditing ? (
          <FormikField
            name='qty'
            label={`QTY (${material?.unit || 'PC'})`}
            type='number'
            width={200}
          />
        ) : (
          <Typography>
            QTY: {qty} {material?.unit}
          </Typography>
        )}
      </Stack>
    </Stack>
  )
}
